<template>
  <b-modal
    size="xl"
    v-model="show"
    id="modal-editar"
    centered
    title="BootstrapVue"
    @hidden="cerrarModal()"
    hide-footer
  >
    <template #modal-title>
      {{ titulo }}
    </template>
    <div class="d-block text-center">
      <b-form
        id="editUserForm"
        class="pl-3 pr-3 form-input"
        @submit.prevent="submit"
      >
        <form-usuario
          v-model="value"
          :user="user"
          :roles="roles"
          :password="password"
        >
          <button
            type="button"
            v-if="cambiarPasswordCondicion"
            class="btn-secundario mx-2"
            @click="cambiarPassword"
          >
            Cambiar contraseña
          </button>
        </form-usuario>
      </b-form>
    </div>
  </b-modal>
</template>

<script>
import FormUsuario from "../formulario/FormUsuario.vue";
import InputRut from "../formulario/InputRut.vue";
export default {
  components: { InputRut, FormUsuario },
  emits: ["input"],
  name: "ModalFormUsuario",
  props: {
    value: Object,
    show: Boolean,
    cerrarModal: Function,
    titulo: String,
    submit: Function,
    roles: Array,
    user: Object,

    password: Boolean,
    cambiarPassword: Function,
    cambiarPasswordCondicion: Boolean,
  },
  methods: {},
};
</script>

<style></style>
